<template>
  <van-overlay :show="showDetail" class-name="sign-box" :lock-scroll="true" @click.stop>
    <div class="sign-wrap">
      <img class="sign-lock" src="../../../assets/matchGuide/lock.png" alt="" />
      <div class="sign-text">快来报名参加赛事指导吧~</div>
      <img class="sign-btn" src="../../../assets/matchGuide/sign_btn.png" alt="" @click="jumpSignUp" />
    </div>
  </van-overlay>
</template>

<script>
export default {
  data() {
    return {
      showDetail: false
    }
  },
  methods: {
    show() {
      this.showDetail = true
    },
    jumpSignUp() {
      this.$emit('jumpLogin')
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-box {
  background: rgba(0, 0, 0, 0.85);
}
.sign-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .sign-lock {
    width: 86px;
    height: 113px;
  }
  .sign-text {
    padding: 38px 0 24px 0;
    font-size: 34px;
    font-weight: bold;
    color: #dcdcdc;
  }
  .sign-btn {
    width: 321px;
    height: 111px;
  }
}
</style>
